<!--
 * @Description:集成接口
 * @Author: 王赵坤
 * @Date: 2023-08-15 11:08:40
 * @LastEditors: 王赵坤
 * @LastEditTime: 2023-09-28 16:29:53
-->
<script>
const WX_URL = 'https://www.univrlab.com/';
const BASE_URL = 'https://www.univrlab.com/'
// const BASE_URL = 'http://univr-api.sublab.cn/';    234523452345
// const BASE_URL = 'http://univr-testapi.sublab.cn/';
 // const BASE_URL=window.location.protocol+"//"+window.location.host+'/';
    export default{
        BASE_URL,
        WX_URL
    }
</script>



// WEBPACK FOOTER //
// src/components/Common/Global.vue